import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Compare } from "@/components/site/Story";
import { CreativeWall, VideoAds } from "@/components/site/Advertising";
import { TimeBack } from "@/components/site/Growth";
import { Calculator, Pricing, Founders, Team } from "@/components/site/Package";
import { FinalCTA, Faq, Footer } from "@/components/site/Closing";

function App() {
    const [businessName, setBusinessName] = useState("");

    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.13, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="App bg-paper font-body text-ink">
            <Nav />
            <main>
                <Hero businessName={businessName} onBusinessName={setBusinessName} />
                <Marquee />
                <Compare />
                <VideoAds />
                <CreativeWall />
                <TimeBack />
                <Calculator />
                <Pricing />
                <Founders />
                <Team />
                <FinalCTA businessName={businessName} onBusinessName={setBusinessName} />
                <Faq />
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
